<p class="h-full flex align-items-center gap-2 align-content-center px-4 border-round-sm bg-primary-100"
  >{{ text ?? 'N/A' }}
  @if (withTooltip) {
    <span
      [pTooltip]="tooltipText"
      tooltipStyleClass="custom-tooltip"
      tooltipPosition="top"
      hideDelay="1000"
      class="pi pi-info-circle pb-1"></span>
  }
</p>
